import article1 from "assets/articles/article1.jpg";
import demo from "assets/articles/demo.jpg";
const Data = [
  {
    id: 0,
    title: "Recyclons nos conserves",
    subtitle:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis nihil aspernatur non, cupiditate ullam veniam perspiciatis assumenda error! Accusantium, suscipit est? Quasi eveniet tempora aperiam ullam quod accusantium aliquid? Voluptate!",
    categorie: "Recyclage",
    picture: demo,
    date: "01-07-2020",
  },
  {
    id: 2,
    title: "Les déchets dans les océans",
    subtitle:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis nihil aspernatur non, cupiditate ullam veniam perspiciatis assumenda error! Accusantium, suscipit est? Quasi eveniet tempora aperiam ullam quod accusantium aliquid? Voluptate!",
    categorie: "Recyclage",
    picture: demo,
    date: "01-07-2020",
  },
];

export default Data;
